<template>
  <div
    v-if="showComponent"
    class="form-group">

    <div v-if="blocksReady">
      <drag-items
        ref="drag-items"
        :data="blocks"
        :stages="suppliersArray"
        :suppliers="suppliers"
        :refresh="refreshList"
        :source="data"
        id-prop="id"
        status-prop="supplier_id"
        :unassigned-value="0"
        :auto-save="true" />
    </div>

    <div
      v-else
      class="pb-4 pt-5 text-center text-muted">
      <div
        class="spinner-border spinner-border-sm text-primary mr-2"
        role="status" />
      Trwa pobieranie zamówień&hellip;
    </div>

  </div>
</template>

<script>
import DragItems from '@/components/others/dragItems';
import ListUtils from '@/utils/ListUtils';

export default {
  name: 'orders-transport',
  components: { DragItems },
  props: {
    date: {
      required: true,
      type: [String, Number]
    },
    keyData: {
      required: true,
      type: Number
    },
    refresh: {
      required: true,
      type: Function
    },
    showComponent: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      blocks: [],
      blocksReady: false,
      data: [],
      suppliers: [],
      suppliersArray: []
    };
  },
  watch: {
    showComponent (value) {
      if (value) {
        this.loadFilteredData();
        return;
      }

      this.data = [];
    },
    date () {
      this.loadFilteredData();
    },
    keyData () {
      this.blocksReady = false;
      this.blocks = [];
    },
    suppliers (items) {
      if (items && items.length) {
        this.suppliersSort();
      }
    }
  },
  mounted () {
    this.loadSuppliers();
  },
  methods: {
    refreshList () {
      this.loadFilteredData();
      this.refresh();
    },
    blocksSort () {
      const array = JSON.parse(JSON.stringify(this.data));
      this.blocks = [];

      for (let i = 0; i < array.length; i++) {
        this.blocks.push({
          id: array[i].id,
          ordering: array[i].ordering,
          index: array[i].ordering,
          supplier_id: array[i].supplier_id || 0,
          supplier_name: array[i].supplier_name || 'NIE PRZYPISANE ZAMÓWIENIE',
          shop_id: array[i].shop_id,
          shop_name: array[i].shop_name,
          shop_address: array[i].shop_address,
          shop_post_code: array[i].shop_post_code,
          shop_city: array[i].shop_city,
          containers_number: array[i].containers_number,
          containers_number_returned: array[i].containers_number_returned,
          customer_name: array[i].customer_name,
          payment_cash: array[i].payment_cash,
          payment_transferred: array[i].payment_transferred,
          payment_card: array[i].payment_card,
          price: array[i].price,
          order: array[i].order_products,
          products: array[i].order_products
        });
      }

      this.blocksReady = true;
    },
    suppliersSort () {
      const array = JSON.parse(JSON.stringify(this.suppliers));

      if (!array.find(s => s.id === 0)) {
        array.unshift({
          id: 0,
          name: 'NIE PRZYPISANE ZAMÓWIENIE',
          email: '',
          type: '',
          active: 1
        });
      }

      this.suppliersArray = array;
    },
    loadSuppliers () {
      let where = {
        active: 1
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/suppliers/items',
        listField: 'suppliers',
        pagination: false,
        params: {
          where
        }
      });
    },
    loadFilteredData () {
      this.blocksReady = false;
      this.blocks = [];
      this.data = [];
      let where = {
        delivery_date: this.date
      };

      this.$http.post('/orders/items', {
        pagination: false,
        where
      }).then(response => {
        if (response.data && response.data.data) {
          this.data = response.data.data;
        } else {
          this.data = [];
        }

        this.blocksSort();
      }).catch(error => {
        console.error(error);
        this.blocksReady = true;
      });
    }
  }
};
</script>
